import axios from "@/plugins/axios.js";
import store from "../store";

export default {
  //New functions should ALWAYS come on top here for easy updates
  sortArrayOfObjectsByObjProperty(arrayOfObjects, objProperty) {
    return arrayOfObjects.slice().sort((a, b) => {
      return a[objProperty].localeCompare(b[objProperty]);
    });
  },
  //for splitting numbers and emails to array
  splitStringToArray(number) {
    if (!number) {
      return [];
    }
    const delimiters = /[,;|\/]/;
    let nums = number.split(delimiters);
    const newArr = [...nums];
    nums = [];
    newArr.forEach((num) => {
      nums.push(num.replace(/\s/g, ""));
    });
    return nums;
  },

  initialiseOrUpdateCompanyDataInStorage(company, site_colors, user = null) {
    if (!company || !site_colors) {
      return;
    }
    store.commit("setCurrentUser", user);
    store.commit("setUserCompany", company);
    store.commit("setThemeColor", site_colors.primary_bg_color);
    store.commit("setSecondaryColor", site_colors.secondary_bg_color);
    store.commit("setAppName", company.name);

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("themeColor", site_colors.primary_bg_color);
    localStorage.setItem("secondaryColor", site_colors.secondary_bg_color);
    localStorage.setItem("appName", company.name);
    localStorage.setItem("userCompany", JSON.stringify(company));
  },

  getCrudTableTableObjTemplate() {
    const tableObj = {
      alevel: 1,
      fk: null,
      ft: null,
      id: null,
      industry: "All",
      name: "service_providers",
    };
    return tableObj;
  },

  async getAllRates(url) {
    const rates = await axios.postDataWithToken(
      url,
      {},
      localStorage.getItem("token")
    );
    return rates;
  },

  //last compare and update below.

  async login(email, password) {
    const response = await axios.postData("/auth/login", {
      email,
      password,
    });

    if (response && response.status != 401) {
      store.commit("setAccessToken", response.token);
      store.commit("setCurrentUser", response.user);
      store.commit("setAuthenticated", true);

      localStorage.setItem("token", response.token);
      localStorage.setItem("authenticated", true);

      return true;
    } else {
      return false;
    }
  },
  async signOut() {
    const response = await axios.postDataWithToken(
      "/auth/logout",
      {},
      localStorage.getItem("token")
    );

    if (response && response.loggedOut) {
      store.commit("setAuthenticated", false);
      store.commit("setCurrentUser", {});
      store.commit("setCurrentStudent", {});
      localStorage.clear();
      location.reload();
    } else {
      alert("Oops, something went wrong!");
      return false;
    }
  },
  async getCurrencyConversionRateFromFrankfurterApi(
    fromCurrencyCode,
    toCurrencyCode
  ) {
    if (fromCurrencyCode != toCurrencyCode) {
      const resp = await fetch(
        `https://api.frankfurter.app/latest?base=${fromCurrencyCode}&symbols=${toCurrencyCode}`
      );
      const data = await resp.json();
      return data.rates[toCurrencyCode];
    } else {
      return 1;
    }
  },
  convertCurrencyFrankfurterApi(amount, conversionRate) {
    const paddedAmount = 2;
    const convertedAmount = this.formatMoney(
      (amount + paddedAmount) * conversionRate
    );
    return convertedAmount;
  },
  async updateModelSingleRow(table, column, id, value) {
    const response = await axios.postDataWithToken(
      "/auth/update-model-single-row",
      {
        table,
        column,
        id,
        value,
      },
      localStorage.getItem("token")
    );
    return response;
  },
  getIDsFromObjs(objArray) {
    const idCollection = [];
    objArray.forEach((id) => {
      if (typeof id == "object") {
        idCollection.push(id.id);
      } else {
        idCollection.push(id);
      }
    });
    return idCollection;
  },

  async updateModelMultipleRows(table, column, ids, value) {
    ids = this.getIDsFromObjs(ids);
    const response = await axios.postDataWithToken(
      "/auth/update-model-multiple-rows",
      {
        table,
        column,
        ids,
        value,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  removeObjectFromArrayByObjectOrObjectID(objArray, selectedObjsArrayOrID) {
    if (
      Array.isArray(selectedObjsArrayOrID) &&
      selectedObjsArrayOrID.length > 0
    ) {
      selectedObjsArrayOrID.forEach((item) => {
        objArray.forEach((rowObj, index) => {
          if (rowObj.id == item.id) {
            objArray.splice(index, 1);
          }
        });
      });
    } else {
      objArray.forEach((rowObj, index) => {
        if (rowObj.id == selectedObjsArrayOrID) {
          objArray.splice(index, 1);
        }
      });
    }
    return objArray;
  },

  async deleteMultipleRows(table, ids) {
    ids = this.getIDsFromObjs(ids);
    const response = await axios.postDataWithToken(
      "/auth/delete-multiple-rows",
      {
        table,
        ids,
      },
      localStorage.getItem("token")
    );
    return response;
  },
  async deleteSingleRow(table, id) {
    const response = await axios.postDataWithToken(
      "/auth/delete-single-row",
      {
        table,
        id,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  async sendGeneralEmail(emailAddress, subject, body, link, linkDescription) {
    const response = await axios.postDataWithToken(
      "/auth/send-general-email",
      {
        emailAddress,
        subject,
        body,
        link,
        linkDescription,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  formatUnderscoreNamesWithFirstCapitalLetters(name) {
    let formattedName = "";
    if (name && name.includes("_")) {
      formattedName = name.replace("_", " ");
    } else {
      formattedName = name;
    }

    const names = formattedName.split(" ");
    if (names.length > 1) {
      let parts = "";
      names.forEach((tab) => {
        parts += this.capitalizeFirstCharacter(tab) + " ";
      });
      formattedName = parts;
    } else {
      formattedName = this.capitalizeFirstCharacter(names[0]);
    }
    return formattedName;
  },

  async sendGeneralEmailNoToken(
    emailAddress,
    subject,
    body,
    link,
    linkDescription
  ) {
    const response = await axios.postData("/send-general-email-no-token", {
      emailAddress,
      subject,
      body,
      link,
      linkDescription,
    });
    return response;
  },
  getObjectKeys(object) {
    return Object.keys(object);
  },
  uploadFile(file, folder) {
    const fileArr = file.name.split(".");
    const ext = fileArr[fileArr.length - 1];
    const extensions = [
      "xls",
      "xlsx",
      "doc",
      "docx",
      "ppt",
      "pptx",
      "png",
      "jpg",
      "jpeg",
      "txt",
    ];

    if (extensions.includes(ext)) {
      const filename = file.name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        const file64 = fileReader.result;
        store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-file",
            {
              base64string: file64,
              filename: filename,
              folder: folder,
            },
            localStorage.getItem("token")
          )
          .then(() => {
            store.commit("setLoader", false);
          });
      });
      fileReader.readAsDataURL(file);
      return true;
    } else {
      return false;
    }
  },
  stripNonDigitsAndCommasFromMoney(amount) {
    if (typeof amount === "number") {
      return amount;
    }
    const newAmount = amount.replace(/[^\d.-]/g, "");
    return newAmount.trim();
  },
  stripCommasFromMoney(amount) {
    if (typeof amount === "number") {
      return amount;
    }
    const newAmount = amount.replace(/[^\d.-]/g, "");
    return newAmount.trim();
  },
  capitalizeFirstCharacter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  getIframeSource(filename) {
    return store.state.apiUrl + "/auth/excel_templates/" + filename;
  },
  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      const i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      const j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : "")
      );
    } catch (e) {
      //console.log(e)
    }
  },
  getDifferenceInHours(dt2, dt1) {
    var diff = (new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
  },
  getColors() {
    return [
      "#F44336",
      "#E91E63",
      "#9C27B0",
      "#673AB7",
      "#3F51B5",
      "#2196F3",
      "#03A9F4",
      "#00BCD4",
      "#009688",
      "#4CAF50",
      "#8BC34A",
      "#CDDC39",
      "#FFEB3B",
      "#FFC107",
      "#FF9800",
      "#FF5722",
      "#795548",
      "#9E9E9E",
      "#607D8B",
      "#000000",
      "#FFFFFF",
      "#F8BBD0",
      "#9575CD",
      "#80CBC4",
      "#FFCC80",
      "#E6EE9C",
      "#E3F2FD",
      "#E0F7FA",
      "#E8F5E9",
      "#FFF9C4",
      "#E8EAF6",
      "#FCE4EC",
      "#FFEBEE",
      "#F3E5F5",
      "#E1F5FE",
      "#FFF3E0",
      "#EFEBE9",
      "#FAFAFA",
      "#ECEFF1",
      "#9FA8DA",

      "#311B92",
      "#FF9800",
      "#37474F",
      "#009688",
      "#2196F3",
      "#9C27B0",
      "#000000",
      "#880E4F",
      "#3E2723",
      "#F44336",
      "#FFAB00",
      "#E65100",
      "#827717",
      "#3E2723",
      "#000000",
      "purple",
    ];
  },
  async getLogos(emis) {
    const logos = await axios.postData("/get-logos-for-given-company", {
      folder: "logos",
      emis: emis,
    });

    return logos;
  },
};
